import React from "react";
import "./OurJourney.css";
import parse from "html-react-parser";
import Common_heading_holder from "../../common-components/common_heading_holder/Common_heading_holder";
import No_data from "../../common-components/No_data/No_data";

const OurJourney = ({ about_us }) => {
  return (
    <div className="our-journey-section mt-3">
      <div className="journey-card">
         <Common_heading_holder
          heading_text={
            <>
              <span className="black-text"> ABOUT </span>
              <span className="blue-text"> US </span>
            </>
          }
        />
        <p className="journey-text">
          {typeof about_us?.content === "string" ? (
            parse(about_us.content)
          ) : (
            <>
            <No_data/>
            <p>No content available.</p>
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default OurJourney;
